import { SelectButton as g } from "./components/SelectButton.es.js";
import { u as h, a as B, b as I, S as M } from "../../SelectOption-a05022b4.js";
import { jsx as t, jsxs as s } from "react/jsx-runtime";
import { forwardRef as R } from "react";
import { useFormControlContext as T, useMultiStyleConfig as k } from "@chakra-ui/react";
import "../../icons/index.es.js";
import "../../atoms/Button/Button.es.js";
import "../Dropdown/Dropdown.context.es.js";
import { DropdownContent as q } from "../Dropdown/components/DropdownContent.es.js";
import "../Dropdown/components/DropdownItem.es.js";
import { Dropdown as z } from "../Dropdown/Dropdown.container.es.js";
const W = R(
  ({
    ariaLabel: m,
    children: r,
    defaultValue: l,
    disableParent: c,
    isDisabled: p,
    isFullWidth: a = !0,
    isInvalid: n,
    maxHeight: f = !0,
    onChange: u,
    onClear: d,
    onClose: S,
    onOpen: v,
    placeholder: o,
    prefix: w,
    showPlaceholder: x = !1,
    testId: C,
    trackId: y,
    value: D,
    variant: b,
    size: j,
    ...F
  }, O) => {
    const e = T(), P = typeof n == "boolean" ? n : e == null ? void 0 : e.isInvalid, i = k("Select", {
      variant: P ? "error" : b,
      size: j
    }), _ = h({ defaultValue: l, children: r, value: D, onChange: u, placeholder: o });
    return /* @__PURE__ */ t(B, { value: _, children: /* @__PURE__ */ t(I, { value: i, children: /* @__PURE__ */ s(
      z,
      {
        disableParent: c,
        isTruncated: !1,
        maxHeight: f,
        onDropdownClose: S,
        onDropdownOpen: v,
        ref: O,
        children: [
          /* @__PURE__ */ t(
            g,
            {
              ariaLabel: m,
              isDisabled: p,
              placeholder: o,
              prefix: w,
              testId: C,
              trackId: y,
              isFullWidth: a,
              onClear: d,
              ...F
            }
          ),
          /* @__PURE__ */ s(q, { __css: i.content, children: [
            x && o && /* @__PURE__ */ t(M, { value: "", children: o }),
            r
          ] })
        ]
      }
    ) }) });
  }
);
export {
  W as Select
};
//# sourceMappingURL=Select.container.es.js.map
